import React, { useMemo } from "react";
import { StyledAppAvatar } from "@lib/components/AppComponents/AppAvatar/index.styled";
import { Avatar, AvatarProps } from "antd";
import { blue } from "@ant-design/colors";
import { CiImageOff } from "react-icons/ci";
import { type AvatarSize } from "@lib/types/General";

type BorderStyle =
  | "solid"
  | "dashed"
  | "dotted"
  | "double"
  | "groove"
  | "ridge"
  | "inset"
  | "outset";

export type AppAvatarProps = AvatarProps & {
  border?:
    | boolean
    | {
        color?: string;
        width?: number;
        borderStyle?: BorderStyle;
      };
  objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down";
  size?: AvatarSize;
};

const AppAvatarComponent: React.FC<AppAvatarProps> = (props) => {
  const { src, icon, border, children, ...rest } = props;

  const borderProps = useMemo(() => {
    if (border) {
      if (typeof border === "object") {
        return {
          color: border?.color || blue[4],
          width: border?.width || 2,
          borderStyle: border?.borderStyle || ("solid" as BorderStyle),
        };
      }
      return { color: blue[4], width: 2, borderStyle: "solid" as BorderStyle };
    }
    return false;
  }, [border]);

  if (children) {
    return (
      <StyledAppAvatar {...rest} children={children} border={borderProps} />
    );
  }

  return (
    <StyledAppAvatar
      {...rest}
      src={src}
      icon={icon || <CiImageOff />}
      border={borderProps}
    />
  );
};

const AppAvatar = Object.assign(AppAvatarComponent, {
  Group: Avatar.Group,
});

export default AppAvatar;
